import { ValidationRule, helpers } from 'vuelidate/lib/validators';

export const float = ((value: string | number): boolean => {
    return (
        !helpers.req(value) ||
        typeof value === 'number' ||
        /^-?\d{1,3}(?:\.\d{3})*(?:,\d{0,2})?$/.test(value)
    );
}) as ValidationRule;
